import React from "react";

import LogContainer from "../../shared/logs";
import MainTemplate from "../mainTemplate";
import { ReactTitle } from "react-meta-tags";

const PrivateLogContainer = () => (
  <MainTemplate>
    <ReactTitle title={`Logs de Auditoria - Reverse Factoring`} />
    <LogContainer />
  </MainTemplate>
);

export default PrivateLogContainer;
